import { theme } from '@tribeplatform/design-system/themes/default'

import { colorTemplates } from './colors/templates.js'
import { Theme } from './types.js'
import { TypographyTheme } from './typography/themes.js'

export const BASE_THEME: Theme = {
  id: 'default',
  colors: colorTemplates.find(template => template.name === 'Default').colors,
  newColors: theme.colors,
  typography: {
    theme: TypographyTheme.system,
  },
}
